import axios from "axios";
import axiosInstance from "../api";

export const CheckAuth = async (data) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASEURL}/generate_token`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const LoginAPI = async (data) => {
  try {
    const response = await axiosInstance.post("admin/login", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const issueToken = async (data) => {
  try {
    const response = await axios.post( `${process.env.REACT_APP_API_BASEURL}/validate_and_issue_token`,data );
    return response;
  } catch (error) {
    throw error;
  }
};

export const refreshToken = async (data) => {
  try {
    const response = await axios.post( `${process.env.REACT_APP_API_BASEURL}/refresh_token_if_valid`,data );
    return response;
  } catch (error) {
    throw error;
  }
};


